export default {"src":"/_next/static/media/inner-4.8060f346.svg","height":74,"width":74,"blurWidth":0,"blurHeight":0};